import type { PropMeta } from '@h5/schema';

/**
 * 物料侧对 PropMeta 的扩展：
 * - multiple：image setter 允许多选（gallery 用）。
 * 带索引签名以满足 zod v4 .meta() 的参数类型；不修改 schema 包。
 */
export type MaterialPropMeta = PropMeta & { multiple?: boolean; [key: string]: unknown };

/** 类型安全的 meta 构造器，保证每个字段都带 label 与 setter。 */
export function meta(m: PropMeta & { multiple?: boolean }): MaterialPropMeta {
  return { ...m };
}
